import { render } from "./ShareModal.vue?vue&type=template&id=c795433a"
import script from "./ShareModal.vue?vue&type=script&lang=ts"
export * from "./ShareModal.vue?vue&type=script&lang=ts"
script.render = render

export default script